'use client';

import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './navbar.module.css';

export function NavBlur() {
  const { scrollY } = useScroll();
  const navOpacity = useTransform(scrollY, [400 + 180, 400 + 280], [0, 1]);

  return (
    <motion.div
      className={styles.navBlur}
      style={{
        opacity: navOpacity,
      }}
    />
  );
}
